import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ciudadService from "../services/ciudad.service";

const initialState = {
    ciudades: [],
    isLoading: false,
    isError: false,
    message: '',
    currentPage: 1,
    totalRows: 0,
};



export const createCiudad = createAsyncThunk(
    "ciudad/create",
    async ( ciudadData, thunkAPI ) => {
        try {
            return await ciudadService.createCiudad(ciudadData);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)


export const getCiudades = createAsyncThunk(
    "ciudades/getCiudades",
    async (data, thunkAPI) => {
        try {
            return await ciudadService.getAllCiudades(data);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)



export const updateCiudad = createAsyncThunk(
    "ciudad/update",
    async (ciudadData, thunkAPI ) => {
        try {
            const token = thunkAPI.getState().auth.user.token;
            return await ciudadService.updateCiudad(ciudadData, token);
        } catch (error) {
            const message = (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)



export const deleteCiudad = createAsyncThunk(
    "ciudades/deleteCiudad",
    async (id, thunkAPI) => {
        try {
            return await ciudadService.deleteCiudad(id);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const getListSelectCiudad = createAsyncThunk(
    "ciudades/getListSelectCiudad",
    async (thunkAPI) => {
        try {
            return await ciudadService.getListSelectCiudad();
        } catch (error) {
            const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const ciudadSlice = createSlice({
    name: "ciudades",
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCiudades.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getCiudades.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.ciudades = action.payload.data; // Asegúrate de que el backend retorne los datos bajo esta estructura
                state.currentPage = action.payload.pagination.por_pagina;
                state.totalRows = action.payload.pagination.cantidad;
            })
            .addCase(getCiudades.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createCiudad.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createCiudad.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.ciudades.push(action.payload);
            })
            .addCase(createCiudad.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deleteCiudad.fulfilled, (state, action) => {
                state.isLoading = false;
                state.ciudades = state.ciudades.filter(ciudad => ciudad.id !== action.meta.arg); // Opcional si quieres filtrar localmente
            })
            .addCase(deleteCiudad.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || 'Error eliminando la ciudad';
            })
            .addCase(updateCiudad.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateCiudad.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.ciudades = state.ciudades.map((ciudad) => 
                    ciudad.id === action.payload.id ? action.payload : ciudad);
            })
            .addCase(updateCiudad.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
              .addCase(getListSelectCiudad.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.ciudades = action.payload; // 👈 el payload ya es el array plano
            })
    }
})

export const { reset } = ciudadSlice.actions;
export default ciudadSlice.reducer;